import appConfig from "../../config/app_config";
import {errors_map} from '@/translation/errors_translation';
import { store } from "../store";

import { NL } from '@/translation/languages/NL';
import { EN } from '@/translation/languages/EN';
import { DE } from '@/translation/languages/DE';

const data = {
  'NL': NL,
  'EN': EN,
  'DE': DE,
};

function translate(text) {
  let lang = window.EventBus.getVue().$store.getters.getLanguage;
  if (typeof data[lang][text] != "undefined") {
    text = data[lang][text];
  } else {
    console.error('TRANSLATE ERROR: Could not find translation for key: ' + text);
  }
  // console.log(text);
  return text;
}

function translateError(errorCode) {
  console.log("errorCode on translateError", errorCode)
  let lang = window.EventBus.getVue().$store.getters.getLanguage;
  if (errorCode == undefined) {
    return {error: errors_map[lang]["SE"], errorCode: "000"}
  }
  let check = errorCode.search("_");
  let e_codes = errorCode.split(' ');
  let code = '';
  if (e_codes.length >= 1 && check != -1) {
    code = e_codes[0].split('_')[1];
  } else {
    code = e_codes[1].substring(0,2).toUpperCase();
  }

  let errorCodeDigit = '0';
  let append = true;
  console.log('translateError', code, e_codes) ;

  if(code == "DA") {
    // specific error
    code = e_codes[0].substring(2);
    append = false;
  }
  console.log("errors map", errors_map, errors_map[lang][code])

  if (typeof errors_map[lang][code] != "undefined") {
    errorCode = errors_map[lang][code];
    // if(append == true)
      errorCodeDigit = (" " + e_codes[0].substring(5));
      if (errorCodeDigit == "040") {
        errorCode = errors_map[lang]["OB_UG"];
      }
      console.log("errorcodedigit?!?!", errorCode, errorCodeDigit)
  } else {
    return {error: errors_map[lang]["SE"], errorCode: "000"}
  }
  return {error: errorCode, errorCode: errorCodeDigit}
}


export { translate, translateError };
